import { CopyCustomFieldServiceImpl } from './services/copy-custom-field-service';
import { CopyCustomFieldService } from './services/copy-custom-field-service.interface';
import { EditCustomFieldServiceImpl } from './services/edit-custom-field-service';
import { EditCustomFieldDialogProxy, EditCustomFieldService } from './services/edit-custom-field-service.interface';
import { RemoveCustomFieldServiceImpl } from './services/remove-custom-field-service';
import { RemoveCustomFieldService } from './services/remove-custom-field-service.interface';
import { SaveCustomFieldAsPublicServiceImpl } from './services/save-custom-field-as-public-service';
import { SaveCustomFieldAsPublicService } from './services/save-custom-field-as-public-service.interface';
import { GetLayerFieldServiceImpl } from './services/get-layer-field-service';
import { GetLayerFieldService } from './services/get-layer-field-service.interface';
import { SelectedCustomFieldsModelImpl } from './models/selected-custom-fields-model';
import { SelectedCustomFieldsModel } from './models/selected-custom-fields-model.interface';
import { CustomFieldsModelImpl } from './models/custom-fields-model';
import { CustomFieldsModel } from './models/custom-fields-model.interface';
import { CustomFieldsServiceImpl } from './services/custom-fields-service';
import { CustomFieldsService } from './services/custom-fields-service.interface';
import { RemoveCustomFieldRepositoryImpl } from './repositories/remove-custom-field-repository';
import { RemoveCustomFieldRepository } from './repositories/remove-custom-field-repository.interface';
import { RemoveCustomFieldApi } from './repositories/apis/remove-custom-field-api.interface';
import { CopyCustomFieldApi } from './repositories/apis/copy-custom-field-api.interface';
import { CopyCustomFieldRepositoryImpl } from './repositories/copy-custom-field-repository';
import { CopyCustomFieldRepository } from './repositories/copy-custom-field-repository.interface';
import { SaveCustomFieldAsPublicRepositoryImpl } from './repositories/save-custom-field-as-public-repository';
import { SaveCustomFieldAsPublicRepository } from './repositories/save-custom-field-as-public-repository.interface';
import { CopyCustomFieldAsPublicApi } from './repositories/apis/copy-custom-field-as-public-api.interface';
import { CustomFieldsRepositoryImpl } from './repositories/custom-fields-repository';
import { CustomFieldsRepository } from './repositories/custom-fields-repository.interface';
import { CustomFieldsApi } from './repositories/apis/custom-fields-api.interface';
import { CustomFieldApiImpl } from './repositories/apis/custom-field-api';
export function customFieldsModule(bind) {
    bind(CopyCustomFieldService).to(CopyCustomFieldServiceImpl);
    bind(EditCustomFieldServiceImpl).toSelf();
    bind(EditCustomFieldService).toService(EditCustomFieldServiceImpl);
    bind(EditCustomFieldDialogProxy).toService(EditCustomFieldServiceImpl);
    bind(RemoveCustomFieldService).to(RemoveCustomFieldServiceImpl);
    bind(SaveCustomFieldAsPublicService).to(SaveCustomFieldAsPublicServiceImpl);
    bind(GetLayerFieldService).to(GetLayerFieldServiceImpl);
    bind(SelectedCustomFieldsModel).to(SelectedCustomFieldsModelImpl);
    bind(CustomFieldsModel).to(CustomFieldsModelImpl);
    bind(CustomFieldsService).to(CustomFieldsServiceImpl);
    bind(RemoveCustomFieldRepository).to(RemoveCustomFieldRepositoryImpl);
    bind(CustomFieldApiImpl).toSelf();
    bind(RemoveCustomFieldApi).to(CustomFieldApiImpl);
    bind(CopyCustomFieldApi).to(CustomFieldApiImpl);
    bind(CopyCustomFieldAsPublicApi).to(CustomFieldApiImpl);
    bind(CustomFieldsApi).to(CustomFieldApiImpl);
    bind(CopyCustomFieldRepository).to(CopyCustomFieldRepositoryImpl);
    bind(SaveCustomFieldAsPublicRepository).to(SaveCustomFieldAsPublicRepositoryImpl);
    bind(CustomFieldsRepository).to(CustomFieldsRepositoryImpl);
}
